// => Blog selector
export const blogsSelector = (state) => state.blogsReducer;

// => Help center selector
export const helpCenterSelector = (state) => state.helpCenterReducer;